import { BaseCategory } from "~/types/baseCategory";
import type { MarketRowTitleField } from "~/utils/getMarketRowText";

export const BREAKING_HERO = {
  title: "Breaking",
  subtitle:
    "Markets moving right now — live probability shifts across all platforms.",
};

export const BREAKING_REFRESH_INTERVAL_MS = 5 * 60 * 1000;

export const BREAKING_PAGE_SIZE = 25;

export const BREAKING_ROW_TITLE_ORDER: readonly MarketRowTitleField[] = [
  "question",
  "marketTitle",
  "eventTitle",
];

export const BREAKING_CATEGORY_PILLS = [
  { slug: null, label: "All" },
  { slug: BaseCategory.Politics, label: "Politics" },
  { slug: BaseCategory.Sports, label: "Sports" },
  { slug: BaseCategory.Crypto, label: "Crypto" },
  { slug: BaseCategory.Economics, label: "Economics" },
  { slug: BaseCategory.Financials, label: "Finance" },
  { slug: BaseCategory.ScienceAndTechnology, label: "Tech" },
  { slug: BaseCategory.Entertainment, label: "Entertainment" },
] as const;

export type BreakingCategorySlug = BaseCategory | null;

export const BREAKING_COLORS = {
  up: "#15803D",
  down: "#DC2626",
  heroUp: "#34d399",
  muted: "#8a8f98",
  urgent: "#DC2626",
  liveDot: "#ef4444",
  dark: "#0B0C0F",
} as const;
